export const WORKPLANMASTERDATASALL_REQUEST = "WORKPLANMASTERDATASALL_REQUEST";
export const WORKPLANMASTERDATASALL_SUCCESS = "WORKPLANMASTERDATASALL_SUCCESS";
export const WORKPLANMASTERDATASALL_FAIL = "WORKPLANMASTERDATASALL_FAIL";